module.exports = __webpack_public_path__ + "img/workshop-marker-v2.8578456d.png";